import React from 'react';
import { Box } from '@mui/material';

type Props = {
  children?: React.ReactNode;
};

export default function SidebarPageWrapper(props: Props): JSX.Element {
  return (
    <Box sx={{ 
        position: "relative",
        display: "flex",
        width: "100%",
        padding: "10px 20px"
      }}>
      {props.children}
    </Box>
  );
}